import type { PulseCdnOptions } from '../types';

export function getPulseCdnIframeUrl(
  encodedPath: string,
  pulseCdnOptions?: PulseCdnOptions,
) {
  const src = `/pulsecdn/frame${encodedPath}`;
  if (!pulseCdnOptions) {
    return src;
  }

  const query = new URLSearchParams({
    pulseCdnOptions: JSON.stringify(pulseCdnOptions),
  });
  return `${src}?${query}`;
}
